import { Component, Inject, OnInit , DestroyRef} from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { CalculationService } from '../../api';
import { calculationDefaults, CalculationsSettingsService } from '../calculations-settings.service';
import { Router } from '@angular/router';
import { AppService } from '../../app-service/kfp.service';
import { ProbabilityParametersService } from '../probability/domain/services/probability-parameters.service';
import { ProbabilityChartService } from '../probability/domain/services/probability-chart.service';
import {ProfileService} from '../../profile/profile.service';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
    selector: 'calculations-dialog',
    templateUrl: './calculations-dialog.component.html',
    styleUrls: ['./calculations-dialog.component.scss'],
    standalone: false
})
export class CalculationsDialogComponent implements OnInit {
    public form: FormGroup;
    public data: any = {};
    public calculations: any = {};
    public isCopy = false;
    public colors = { primary: 'darkGreen', secondary: 'brown' };

    constructor(@Inject(MAT_DIALOG_DATA) public dataRef: any,
        private dialogRef: MatDialogRef<any>,
        private readonly formBuilder: FormBuilder,
        private readonly calcService: CalculationService,
        private readonly router: Router,
        private profileService: ProfileService,
        private readonly appService: AppService,
        private readonly calcSettingsService: CalculationsSettingsService,
        private _probabilityParametersService: ProbabilityParametersService,
        private _probabilityChartService: ProbabilityChartService, private readonly destroyRef: DestroyRef) {
        this.data = dataRef.calculation;
        if (this.dataRef.copy) {
            this.isCopy = true;
        }

        // Při provním ukládání nepředvyplnit uživatele - KFP-893
        if(this.data.draft){
            this.data.clientName = undefined;
            this.data.clientSurname = undefined;
        }

        this.form = this.formBuilder.group({
            calcName: [this.data.calcName || '', [Validators.required, Validators.maxLength(35)]],
            clientName: [this.data.clientName || '', Validators.maxLength(50)],
            clientSurname: [this.data.clientSurname || '', Validators.maxLength(50)],
            description: [this.data.description || '', Validators.maxLength(255)],
        });
    }

    ngOnInit(): void {
        this.dialogRef.updateSize('544px', '590px');
    }

    public submit(): boolean {
        if (this.isCopy) {
            delete this.data.id;
        }
        if (this.form.invalid) {
            // eslint-disable-next-line
            for (const controlName in this.form.controls) {
                this.form.controls[controlName].markAsTouched();
            }
            return false;
        }

        if (!this.data.id) {
            this.data.draft = false;
            if (!this.data.inputData) {
                this.data.inputData = calculationDefaults[this.data.calculationType];
            }
            this.calcService
                .createNewCalculation(this.data)
                .pipe(takeUntilDestroyed(this.destroyRef), )
                .subscribe((response: any) => {
                    const sharedData = {
                        calculationType: this.data.calculationType,
                        title: this.data.calcName,
                        concept: false,
                        storable: true,
                        download: true,
                        new: true,
                        data: this.data.inputData,
                        charts: this.data.charts,
                    };
                    this.appService.setData(sharedData);
                    this.router.navigate([this.calcSettingsService.getCalcRoute(response.calculationType)], {
                        queryParams: {id: response.id},
                    });
                    this.dialogRef.close(response);
                });
        } else {
            // Apply form values to data object before updating
            this.data.calcName = this.form.value.calcName;
            this.data.clientName = this.form.value.clientName;
            this.data.clientSurname = this.form.value.clientSurname;
            this.data.description = this.form.value.description;
            this.data.draft = false;

            this.calcService
                .updateCalculation(this.data.id, this.data)
                .pipe(takeUntilDestroyed(this.destroyRef), )
                .subscribe((response: any) => {
                    // Update the AppService with the new title
                    this.appService.updateTitle(response.calcName);
                    this.dialogRef.close(response);
                });
        }
        return false;
    }
}
